import React from "react";
import { Stack, Typography } from "@mui/material";
import underConstructionImage from "../../assests/errorImages/underConstructionImage.svg";

const ContactSupport = ({ pageHeight }) => {
    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            height={pageHeight || "100dvh"}
            width="100%"
            sx={{
                bgcolor: "#111218",
                px: 2,
                textAlign: "center",
            }}
        >
            <img
                src={underConstructionImage}
                alt="under_construction"
                style={{ width: "380px", maxWidth: "85vw", margin: 0, padding: 0 }}
            />
            <Typography
                sx={{
                    fontSize: { xs: "24px", md: "32px" },
                    fontWeight: 600,
                    color: "#EAEAEB !important",
                    lineHeight: "42px",
                    mt: 3,
                }}
            >
                To know more, please contact
            </Typography>
            <Typography
                component="a"
                href="mailto:support@bhumiitech.com"
                sx={{
                    fontSize: { xs: "18px", md: "22px" },
                    color: "#00FFFF !important",
                    fontWeight: 500,
                    mt: 1,
                    textDecoration: "none",
                    "&:hover": {
                        textDecoration: "underline",
                    },
                }}
            >
                support@bhumiitech.com
            </Typography>
        </Stack>
    );
};

export default ContactSupport;
